import { render, staticRenderFns } from "./TableCommon.vue?vue&type=template&id=acfcdbba&scoped=true&"
import script from "./TableCommon.vue?vue&type=script&lang=ts&"
export * from "./TableCommon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfcdbba",
  null
  
)

export default component.exports